import { cva as p } from "class-variance-authority";
import * as e from "react";
import { c as u } from "../cn-Edy-X8i3.js";
import "clsx";
import "tailwind-merge";
const v = p(
  "inline-flex select-none items-center justify-center gap-2 whitespace-nowrap rounded-sm border px-6 py-[calc(0.75rem_-_1px)] text-center align-middle text-base font-bold transition-colors focus-visible:outline-none focus-visible:ring-1 disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-20",
  {
    variants: {
      color: {
        primary: [
          "spit-btn-primary",
          "border-blue-500",
          "bg-blue-500",
          "text-primary-inverted",
          "hover:border-blue-700",
          "hover:bg-blue-700"
        ],
        secondary: [
          "spit-btn-secondary",
          "border-gray-50",
          "bg-gray-50",
          "text-primary",
          "hover:border-gray-300",
          "hover:bg-gray-300"
        ],
        error: [
          "spit-btn-error",
          "border-red-600",
          "bg-red-600",
          "text-primary-inverted",
          "hover:border-red-900",
          "hover:bg-red-900"
        ]
      },
      size: {
        sm: ["px-4", "py-2"]
      },
      variant: {
        outline: ["bg-white"]
      },
      fullWidth: {
        true: ["flex", "w-full"]
      },
      fontSize: {
        lg: "text-[1.125rem] leading-6"
      }
    },
    compoundVariants: [
      {
        color: "primary",
        variant: "outline",
        class: ["text-blue-500", "hover:text-primary-inverted"]
      },
      {
        color: "secondary",
        variant: "outline",
        class: ["hover:border-gray-200", "hover:bg-gray-200"]
      },
      {
        color: "error",
        variant: "outline",
        class: [
          "text-red-600",
          "hover:bg-red-600",
          "hover:text-primary-inverted",
          "hover:border-red-600"
        ]
      }
    ],
    defaultVariants: {
      color: "primary"
    }
  }
), w = e.forwardRef(
  function(o, i) {
    const {
      children: a,
      className: n,
      color: l,
      disabled: r,
      isLoading: t = !1,
      fontSize: s,
      fullWidth: d,
      size: c,
      variant: b,
      ...m
    } = o;
    return /* @__PURE__ */ e.createElement(
      "button",
      {
        ref: i,
        className: u(
          v({ color: l, fontSize: s, fullWidth: d, size: c, variant: b }),
          n,
          { "relative text-transparent pointer-events-none": t }
        ),
        "aria-disabled": r,
        disabled: r,
        ...m
      },
      a,
      t ? /* @__PURE__ */ e.createElement("div", { className: "absolute inset-0 flex items-center justify-center" }, /* @__PURE__ */ e.createElement("div", { className: "size-6 animate-spin rounded-circle border-4 border-white/25 border-t-white" })) : null
    );
  }
);
export {
  w as Button
};
